<template>
  <el-dialog :title="dialogTitle" :visible.sync="open" :center="true" width="60%" @close="cancel"
    :close-on-click-modal="false">
    <div>
      <el-row>
        <el-col :span="6">
          <span>产品：{{data.data?data.data[0].productName:'-'}}</span>
        </el-col>
        <el-col :span="6">
          <span>规格型号：{{data.data?data.data[0].specName:'-'}}</span>
        </el-col>
        <el-col :span="6">
          <span>批次号：{{data.data?data.data[0].batch:'-'}}</span>
        </el-col>
      
      </el-row>
      <div style="margin: 10px 0px">
        <el-dropdown @command="batchPrintChange"  style="margin: 10px 10px;">
          <el-button type="primary" size="small">
            批量打印<i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="1">RFID打印</el-dropdown-item>
            <el-dropdown-item command="2">普通打印</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <el-table :data="data.data" border style="width: auto; margin: 10px 0px" stripe :header-cell-style="{ background: '#DDEBFF' }"
        @selection-change="handleSelectionChange">
        <el-table-column align="center" :reserve-selection="true" type="selection" fixed width="55"> </el-table-column>
        <el-table-column type="index" width="50" label="序号"> </el-table-column>
        <el-table-column prop="itemTagCode" label="件装标签码" min-width="180"></el-table-column>
        <el-table-column  label="数量" width="180">
          <template slot-scope="scope">
            {{ 1+scope.row.unit +' ' +`（${scope.row.number} ${scope.row.minUnit}）`}}
          </template>
        </el-table-column>
        <el-table-column prop="tagCodeTypeName" label="标签类型" width="180"></el-table-column>
        <el-table-column prop="printTimes" label="打印次数" width="180"></el-table-column>
        <el-table-column fixed="right" prop="operation" label="操作" width="200">
          <template slot-scope="scope">
            <el-button type="text" size="small" v-preventReClick @click="viewDetails(scope.row)" class="color-blue">详情</el-button>
            <el-button type="text" size="small" v-preventReClick @click="print(scope.row)" class="color-blue">RFID打印</el-button>
            <el-button type="text" size="small"  @click="print1(scope.row)" class="margin-left20 color-blue">普通打印</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </el-dialog>
</template>


<script>
import {
  GetTagCodePrintData,
  GetTagCodeRfidPrintData
} from "@/api";
import GetDataMixin from "@/mixin/getData-mixin";
export default {
  mixins: [GetDataMixin],
  data () {
    return {
      dialogTitle: '件装标签明细'
    }
  },
  props: {
    open: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: {}
    },
  },
  mounted () {
    this.rfidSocketApi.init(this.onmessage, this.onopen);
  },
  beforeDestroy () {
    this.rfidSocketApi.clearBingMethods();
  },
  methods: {
    onmessage (e) {
      // window.console.log("收到消息啦:" + e.data);
      var data = JSON.parse(e.data);
      if (data.Successful) {
        this.$my_message("打印成功", "success");
      } else {
        this.$my_message("打印失败：" + data.Message, "error");
      }
    },
    onopen () {
      console.log("连接成功了哦");
    },
    viewDetails (row) {
      
      this.$emit('viewDetails', row.itemTagCode);
    },
    handleDelete () {
      this.data.data.forEach((item,index) => {
        if (this.ids.includes(item.id)) {
          this.data.data.splice(index, 1);
        }
      });
      
    },
    cancel () {
      this.$emit('close');
    },
    //普通打印
    print1 (row) {
      return new Promise((resolve, reject) => {
        let data = {
          tagCode: row.itemTagCode,
          isSingle:row.isRfid==1?1:0,
          isItemTagCode :1,
        }
        return GetTagCodePrintData(data).then((res) => {
          var result = res.returnData
          this.$set(row,'printTimes',row.printTimes+1)
          var printData = this.printDataConvert(result.printData)
          this.sendPrintMessage(JSON.stringify(printData));
          resolve(res.returnData);
        });
      });
    },
    print (row, notRefresh) {
      return new Promise((resolve, reject) => {
        return GetTagCodeRfidPrintData({
          tagCode: row.itemTagCode,
        }).then((res) => {
          var action = "PrintSingle";
          if (row.isRfid != 1) {
            action = "PrintPack";
          }
            if(this.system_setting.RFIDTempSite){
            this.$my_message("打印成功", "success");
                resolve(res.returnData);
                   this.$set(row,'printTimes',row.printTimes+1)
                return
            }
          var data = {
            Action: action,
            Content: res.returnData,
          };
          this.$set(row,'printTimes',row.printTimes+1)
          this.rfidSocketApi.sendSock(data);
          resolve(res.returnData);
        });
      });
    },
    batchPrintChange (num) {
      this.batchPrintType = num
      if (!this.multipleSelection) {
        this.$my_message("请选择要打印的数据", "warning");
        return;
      }
 

      const map = new Map();
      for (let i = 0; i < this.multipleSelection.length; i++) {
        if ("itemTagCode" in this.multipleSelection[i]) {
          this.multipleSelection[i].itemTagCode = this.multipleSelection[i].itemTagCode;
        }
      }
      this.newArr = this.multipleSelection.filter(
        (key) => !map.has(key.itemTagCode) && map.set(key.no, 1)
      );

      this.printForeach(0);
    },

    printForeach (i) {
      if (i != this.newArr.length) {
        let notRefresh = true;
        if (i == this.newArr.length - 1) {
          notRefresh = false;
        }
        if(this.batchPrintType==1){
          this.print(this.newArr[i], notRefresh).then((res) => {
            i++;
            setTimeout(() => {
              this.printForeach(i);
            }, 1000);
          });
        }else{
          this.print1(this.newArr[i], notRefresh).then((res) => {
            i++;
            setTimeout(() => {
              this.printForeach(i);
            }, 1000);
          });
        } 
      } else {
        if(this.$refs.customTable){
          this.$refs.customTable.callChildMethod().clearSelection()
        }
        if (this.$refs.multipleTable) {
          this.$refs.multipleTable.clearSelection()
        }
        // this.getData()
      }
    },
  }
}
</script>